import React from 'react'

const HorizontalLine = () => {
  return (
    <div className='HorizontalLine'></div>
  )
}

export default HorizontalLine